const Routes_gral = {
    abms: '/abms',
    activos: '/activos',
    activoDetail: '/activos/:codActivo?',
    addReq: '/addReq',
    appMobile: '/appMobile',
    ayuda:'/ayuda',
    categoriasRRHH: '/categoriasRRHH',
    checkList: '/checkList',
    checkListRegistrados: '/checkListRegistrados',
    confirmEmail: '/confirmEmail/:token',
    consumos: '/consumos',
    opd: '/opd',
    control: '/Control',
    diccionario: '/diccionario',
    documentos: '/documentos',
    error:'/error',
    group: '/Group',
    home: '/Home',
    legajos: '/legajos',
    login: '/',
    mantenimientos: '/mantenimientos',
    newPassword: '/newPassword/:token',
    notificaciones: '/notificaciones',
    procedimientos: '/procedimientos',
    procsProgramados: '/procsProgramados',
    product: '/Product',
    proveedores: '/proveedores',
    templatesProduccion: '/templatesProduccion',
    recoverPassword: '/recoverPassword',
    reports: '/reports',
    signup: '/signup',
    tableroSupervisor: '/tabSupervisor',
    globalSettings: '/globalSettings',
    user: '/User',
    bloqueadosReserva: '/bloqueadosReserva',
    reservasCanchas: '/reservasCanchas',
    misReservas: '/misReservas',
    explicacionReservas: '/explicacion-reservas',
}

export default Routes_gral